<section class="logs">

  <div class="logs__tabs" role="tablist" aria-label="<%= _lcs( 'Protokolle' ) %>">
    <button type="button" class="logs__tab logs__tab--active" data-tab="system"
            role="tab" aria-selected="true" aria-controls="logs-panel-system">
      <i class="icon icon--scroll-text"></i> <%= _lcs( 'Systemprotokoll' ) %>
    </button>
    <button type="button" class="logs__tab" data-tab="api"
            role="tab" aria-selected="false" aria-controls="logs-panel-api">
      <i class="icon icon--activity"></i> <%= _lcs( 'API-Anfragen' ) %>
    </button>
  </div>

  <!-- System log (logs."system") -->
  <div class="logs__panel" data-panel="system" id="logs-panel-system" role="tabpanel">
    <div class="logs__state" data-id="system-state"></div>
  </div>

  <!-- API request log (logs."apiRequestLog") — loaded lazily on first activation -->
  <div class="logs__panel" data-panel="api" id="logs-panel-api" role="tabpanel" hidden>
    <div class="logs__state" data-id="api-state"></div>
  </div>

</section>
